//
//
//
//

import AQBrowserNotSupported from "@/components/Generics/AQDeniedPage/AQBrowserNotSupported.vue";
import { isValidPlatform, isValidBrowser } from "@/assets/js/appFunc";

export default {
    components: { AQBrowserNotSupported },
    computed: {
        isValidPlatform,
        isValidBrowser
    }
};
